export interface CmsBlockModel<T = any> {
	name: string;
	key: string;
	description: string;
	content: T;
	activated: boolean;
	lastModified?: Date;
	created?: Date;
}
export type CmsBlockModelPublicResponse<T = any> = Pick<CmsBlockModel<T>, "activated" | "content">;

export enum CmsBlockKey {
	BROKERS_CONFIG = "brokers_config",
	TM_HELP_MAIN = "tm_help_main",
	TM_FAQ_DE = "tm_faq_de",
	TM_FAQ_EN = "tm_faq_en",
	TM_STARTPAGE_STOERER_DE = "tm_startpage_stoerer_de",
	TM_STARTPAGE_STOERER_EN = "tm_startpage_stoerer_en",
	PROMOTIONS = "promotions",
	TM_WEBVIEWER_ANNOTATION_HELP = "tm_webviewer_annotation_help",
	SURVEYS = "surveys",
	FUNCTIONAL_LINKS = "functional_links",
	TMA_QR_CODE_CONFIG = "tma_qr_code_config",
	TMA_MESSAGE_TEMPLATE_VARIABLES = "tma_message_template_variables",
}

export enum CmsBlockPublicKey {
	PUBLIC_DOCUMENTS = "public_documents",
	MAINTENANCE_TIME = "maintenance_time",
	REGISTRATION_COUNTRIES = "registration_countries",
}

/** Types for cms block 'public_documents' */
export type PublicDocumentsCmsBlock = {
	termsAndConditions: PublicDocumentInfo;
	priceLists: PublicDocumentInfo;
	dataProtectionInformation: PublicDocumentInfo;
	orderProcessingAgreement: PublicDocumentInfo;
	shippingInstructionSwitzerland: PublicDocumentInfo;
};

export type PublicDocumentInfo = {
	urlDe: string;
	urlEn: string;
	labelDe: string;
	labelEn: string;
	isAbsoluteUrl?: boolean;
};

/** Types for cms block 'tm_webviewer_annotation_help' */
export type WebviewerAnnotationHelpCmsBlock = {
	steps: Array<{
		title: {
			de: string;
			en: string;
		};
		body: {
			de: string;
			en: string;
		};
		imageSrc?: {
			de: string;
			en: string;
		};
		videoSrc?: {
			de: string;
			en: string;
		};
	}>;
};

/** Types for cms block 'brokers_config' */
export type BrokersConfigCmsBlockContent = Record<string, BrokerConfig>;
export type BrokerConfig = {
	sfProperties?: Record<string, string>;
	sapProperties?: Record<string, string>;
	promotionCode?: string;
	entitledProductKeys?: string[];
};

/** Types for cms block 'surveys' */
export type SurveysCmsBlockContent = {
	nps: { de: string; en: string };
	csat: { de: string; en: string };
};

/** Types for cms block 'functional_links' */
export type FunctionALLinksCmsBlockContent = {
	courses: { de: string; en: string };
	webinar: { de: string; en: string };
};

/** Types for cms block 'tma_qr_code_config' */
export type TmaQrCodeConfigCmsBlockContent = {
	baseUrl?: string;
};

/** Types for cms block 'registration_countries' */
export type RegistrationCountryOption = {
	country: string;
	code: string;
	labelDe?: string;
	labelEn?: string;
};
export type RegistrationCountriesCmsBlockContent = RegistrationCountryOption[];
